import React, { useEffect, useState } from 'react';
import { BackButton } from '@/components/BackButton';
import { useNavMenuStore } from '@/store/useNavMenuStore';
import { useNavigate } from 'react-router-dom';
import styles from './VoucherHistoryPage.module.scss';
import { ReactComponent as ClockLogo } from '../../assets/Icons/clockv.svg';
import { ReactComponent as StarLogo } from '../../assets/Icons/star.svg';
import { getVoucherHistory } from '@/api/modules/Voucher/voucher';

const VoucherHistoryPage = () => {
  const navigate = useNavigate();
  const [history, setHistory] = useState<any[]>([]);
  useEffect(() => {
    useNavMenuStore.getState().setVisibility(false);
    document.body.classList.add('voucher-history-page');
    return () => {
      useNavMenuStore.getState().setVisibility(true);
      document.body.classList.remove('voucher-history-page');
    };
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const data = await getVoucherHistory();
      setHistory(data.redemptions);
    };
    fetchData();
  }, []);

  const handleBackClick = () => {
    navigate('/voucher');
  };

  return (
    <div className={styles.container}>
      <BackButton onClick={handleBackClick} />
      <div className={styles.content}>
        <div className={styles.title}>
          <ClockLogo />
          История
        </div>

        <div className={styles.items}>
          <div className={styles.headers}>
            <div className={styles.headers__date}>Дата</div>
            <div className={styles.headers__word}>Промокод</div>
            <div className={styles.headers__reward}>Награда</div>
          </div>

          {history.map((item) => (
            <div key={item.id} className={styles.item}>
              <div className={styles.item__date}>
                {new Date(item.created_at).toLocaleDateString('ru-RU', {
                  day: '2-digit',
                  month: '2-digit',
                  year: 'numeric',
                })}
              </div>
              <div className={styles.item__word} title={item.code_mask}>
                {item.code_mask}
              </div>
              <div className={styles.item__amount}>
                <StarLogo className={styles.star} />
                {item.reward.amount}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default VoucherHistoryPage;
